/**
 * Known accounts — tiny localStorage-backed roster of accounts this
 * device has signed in with. Powers the "Switch Account" flow in the
 * sidebar so users can hop between accounts without hand-typing the
 * username each time.
 *
 * SECURITY: we intentionally do NOT persist passwords or tokens. Each
 * switch requires re-entering the password — the roster is just a
 * convenience lookup of usernames + display names.
 */

const STORAGE_KEY = 'mantle:known_accounts';
const MAX_ACCOUNTS = 6;

function readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRaw(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* quota — swallow, we can rebuild on next login */
  }
}

export function listKnownAccounts() {
  return readRaw()
    .filter(a => a && typeof a.username === 'string' && a.username.trim())
    .sort((a, b) => (b.last_used_at || 0) - (a.last_used_at || 0));
}

export function recordAccount({ username, name, workspace_name }) {
  if (!username) return;
  const list = readRaw().filter(a => a.username !== username);
  list.unshift({
    username,
    name: name || username,
    workspace_name: workspace_name || '',
    last_used_at: Date.now(),
  });
  writeRaw(list.slice(0, MAX_ACCOUNTS));
}

export function forgetAccount(username) {
  writeRaw(readRaw().filter(a => a.username !== username));
}
